import Spinner from '../Spinner';
import { Root } from './styles';

const LoadingOverlay = () => {
  return (
    <Root>
      <Spinner size="xLarge" />
    </Root>
  );
};

export default LoadingOverlay;
